import React, { Fragment } from 'react'
import { object } from 'prop-types'
import styled from 'styled-components'

import Card from '@taglivros/oef_componentes/build/components/card'
import Loader from '@taglivros/oef_componentes/build/components/loader'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import FormDadosPessoais from './FormDadosPessoais'
import { empty, isEmptyObject } from '../../../utils/helpers/helpers'
import { formatTelefone, formatCPF, formatDataNascimento, formatReferencePronoun } from '../../../utils/formatter/formatter'
import { useAssociado } from '../../../contexts/AssociadoContext'

const WrapperDadosPessoais = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;

  ul {
    li {
      ${StyleGuide.tipografia.textoPequeno}

      &:not(:last-of-type) {
        margin-bottom: 8px;
      }
    }
  }

  span {
    ${StyleGuide.tipografia.textoDefault}
    ${StyleGuide.boldFonte}
    color: ${StyleGuide.cores.azul};
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 20px;
  }
`

const CardDadosPessoais = ( { dadosAssociado } ) => {
  const { openFormularioDadosPessoais, atualizarDadosAssociado, setToggleFormAlterarDados } = useAssociado()

  const atualizarDados = dadosAssociadoAtualizado => {
    if ( !empty( Object.values( dadosAssociadoAtualizado ) ) ) {
      atualizarDadosAssociado( dadosAssociadoAtualizado )
    }
  }

  return (
    <WrapperDadosPessoais>
      <Card>
        { isEmptyObject( dadosAssociado ) ?
          <Loader isCenter /> :
          <div>
            { openFormularioDadosPessoais ?
              <FormDadosPessoais
                dadosAssociado={ !isEmptyObject( dadosAssociado ) && dadosAssociado }
                onConfirmar={ atualizarDados }
              /> :
              <Fragment>
                <span onClick={ () => setToggleFormAlterarDados( true ) }>editar</span>

                <ul>
                  <li>{ `${dadosAssociado.nome} ${dadosAssociado.sobrenome}` }</li>

                  <li>{ `E-mail: ${dadosAssociado.email}` }</li>

                  <li>{ `CPF: ${formatCPF( dadosAssociado.cpf )}` }</li>

                  <li>{ `Telefone: ${formatTelefone( dadosAssociado.telefone )}` }</li>

                  <li>{ `${dadosAssociado.dtNascimento ? `Data de nascimento: ${formatDataNascimento( dadosAssociado.dtNascimento, '-', '/' )}` : ''}` }</li>

                  <li>{ `${dadosAssociado.sexo ? `Como podemos nos referir a você: ${formatReferencePronoun( dadosAssociado.sexo )}` : ''}` }</li>
                </ul>
              </Fragment>}
          </div>}
      </Card>
    </WrapperDadosPessoais>
  )
}

CardDadosPessoais.propTypes = {
  'dadosAssociado': object.isRequired
}

export default CardDadosPessoais
